module.exports = __webpack_public_path__ + "a7a2736c416de46471d2c503d900a5d3.png";